import {ColumnGroup} from 'notebook/structured-tables/columns/ColumnDefinitions';
import {SchemaAndColumnGroup} from 'notebook/structured-tables/StructuredTableConstants';
import APIUtil from 'util/APIUtil';

function schemaMatchesColumnGroupIfGiven(schema: SchemaAndColumnGroup, group?: ColumnGroup): boolean {
  return group ? schema.columnGroup === group : true;
}

/**
 * Return the first schema that matches the given column group
 */
export function extractContainerSchemaAndColumnGroup(
  schemas: Array<SchemaAndColumnGroup>,
  columnGroup?: ColumnGroup
): SchemaAndColumnGroup | null {
  return (
    schemas.find(
      (schema: SchemaAndColumnGroup) =>
        APIUtil.isContainerSchema(schema.id) && schemaMatchesColumnGroupIfGiven(schema, columnGroup)
    ) ?? null
  );
}

/**
 * Return the first schema that matches the given column group
 */
export function extractPlateSchemaAndColumnGroup(
  schemas: Array<SchemaAndColumnGroup>,
  columnGroup?: ColumnGroup
): SchemaAndColumnGroup | null {
  return (
    schemas.find(
      (schema: SchemaAndColumnGroup) =>
        APIUtil.isPlateSchema(schema.id) && schemaMatchesColumnGroupIfGiven(schema, columnGroup)
    ) ?? null
  );
}
